import cookie from 'js-cookie';
import { useCallback } from 'react';
import { httpClient } from '@alfa-bank/site-http-client';
import { ROUPER_PERSONALIZATION_URL } from '@alfa-bank/site-envconfig';

import type { IBanditCallback } from '../models';

export const useRouperPersonalizationCallBack = (isAnalitycsEnabled: boolean) => {
    const rewardHash = cookie.get('reward_hash');

    return useCallback(
        ({ tagGroupId }: IBanditCallback) => {
            if (
                !isAnalitycsEnabled ||
                !rewardHash ||
                !ROUPER_PERSONALIZATION_URL() ||
                tagGroupId === undefined
            ) {
                return;
            }

            const url = ROUPER_PERSONALIZATION_URL();

            httpClient
                .post(url, {
                    tagGroupId: tagGroupId,
                    contextHash: rewardHash,
                })
                .catch(
                    /* istanbul ignore next */ err =>
                        console.error('не получилось послать запрос', err)
                );
        },
        [isAnalitycsEnabled, rewardHash]
    );
};
